import HeaderNav from 'components/header-nav';
import loaderHtml from 'components/loader';
import { redirect } from 'utils/helpers';
import Confirmbox from 'components/confirm-box';
import { apiUrl, codeToRole } from 'config/constants';


'use strict';

const Contact = {

    /**
     * Initialize the view
     */
    init() {
        this.$contactForm = $('#contact-form');

        $.material.init();

        this.$body = $('body');
        this.$body.append(`<div class='loader-overlay'>${loaderHtml}</div>`);
        this.$body.removeClass('hidden');
        this.$internationalList = $('.js-international');
        this.$cityManagersTitle = $('.js-CM');
        this.$supplierTitle = $('.js-Supp');
        this.$cityManagersList = $('.js-cityManagers');
        this.$suppliersList = $('.js-suppliers');
        this.users = {};
        this.$personClone = $('.person-clone').clone().removeClass('hidden').removeClass('.person-clone');
        this.$flagClone = this.$personClone.find('.sprite-container').remove();

        this.$inviteAll = $('#invite-all');
        this.$inviteAll.append(`<div class="loader-overlay">${loaderHtml}</div>`);
        this.$inviteAllModal = this.$inviteAll.remodal({ hashTracking: false });

        HeaderNav.init({
            activeLink: 'contact'
        }).then((success) => {
            if (success) {
                this.user = HeaderNav.me();
                this.userPermissions = HeaderNav.permissions();
                this.getRequest(this.userPermissions);
            }
            else {
                redirect('/');
            }
        });

        this.activateValidator();
        this.bindEvents();

    },


    getRequest(permissions) {
        // {"role_type":0,"id":0}
        // {"isLoggedIn":false}

        let settings = { url: apiUrl + 'contact/getAllTheCM', type: 'get', data: null, dataType: 'json', xhrFields: { withCredentials: true } };

        $.ajax(settings)
            .then((response) => {
                this.separateCMfromSupp(response);
                this.showPeople(permissions);
            }, (error) => {
                $.snackbar({ content: 'An error occurred while getting the city contacts.' });
            });


    },

    separateCMfromSupp(users) {
        this.allUsers = users;
        this.suppliers = users.filter((user) => {
            return (user.role_type == 3 && user.cities.length > 0);
        });
        this.users = users.filter((user) => {
            return (user.role_type == 2 && user.cities.length > 0);
        });

    },

    showPeople(permissions) {

        if (!permissions.isLoggedIn) {


            this.$internationalList.append(`<li>
                <div class="person-contact">
                    <div class="person-contact__left">
                        <div class="person__languages js-person-languages">
                            <div class="sprite-container"><span class="sprite"></span></div>
                        </div>
                        <img src="images/header-logo-color.png" class="person-contact__image" alt="user avatar" />
                    </div>
                    <div class="person-contact__right">
                        <p id="js-name">International | Inquiries</p>
                        <h4>Media & International Enquiry</h4>
                        <p id="user-email" class="email hidden">info@mundolingo.org</p>
                        <p id="js-city" class="hidden">Mundo Lingo international contact</p>
                    </div>
                </div>
                </li>`);

            if (this.users.length) {

                this.$cityManagersTitle.text('Contact your City');
                this.$cityManagersList.append(this.getAllCM(this.users));
            }
        }
        else {

            this.$internationalList.append(`<li>
                <div class="person-contact">
                    <div class="person-contact__left">
                        <div class="person__languages js-person-languages">
                            <div class="sprite-container"><span class="sprite"></span></div>
                        </div>
                        <img src="images/header-logo-color.png" class="person-contact__image" alt="user avatar" />
                    </div>
                    <div class="person-contact__right">
                        <p id="js-name">International | Inquiries</p>
                        <h4>Media & International Enquiry</h4>
                        <p id="user-email" class="email hidden">info@mundolingo.org</p>
                        <p id="js-city" class="hidden">Mundo Lingo international contact</p>
                    </div>
                </div>
                </li>`);


            if (this.users.length) {

                if (this.user.role_type == 2) {

                    let citySupp = this.appendSuppliers();

                    if (citySupp.length > 0) {
                        this.$suppliersList.append(this.getAllCM(citySupp));
                        this.appendCMs();
                    }
                    else {
                        this.$suppliersList.append('<h4>- There is no supplier for your city.</h4>');
                        this.appendCMs();
                    }

                }
                else {
                    this.appendCMs();
                }
            }
        }
    },

    appendCMs() {
        this.$cityManagersTitle.text('Contact your City');
        let cityCM = [];
        for (let i in this.users) {
            if (this.user.cities.length > 0) {
                for (let o in this.user.cities) {
                    if (this.users[i].cities[0].id === this.user.cities[o].id) {
                        cityCM.push(this.users[i]);
                    }
                }
            }
        }
        this.$cityManagersList.append(this.getAllCM(cityCM));
    },

    appendSuppliers() {
        this.$supplierTitle.text('Contact your Supplier');
        let citySupp = [];

        this.suppliers.forEach((supp) => {
            this.user.cities.forEach((city) => {
                if (supp.cities[0].id == city.id) {
                    citySupp.push(supp);
                }
            });
        });

        return citySupp;
    },

    getAllCM(cmArr) {
        let $people = [];

        for (let i in cmArr) {
            let $clone = this.$personClone.clone();
            let $flags = [];

            if (cmArr[i].cities[0]) {
                $clone.addClass(`--c${(Math.floor(Math.random() * 5) + 1)}`);
                $clone.find('.person-contact__image').prop('src', cmArr[i].avatar);
                $clone.find('#js-name').text(`${cmArr[i].first_name} ${cmArr[i].last_name}`);
                $clone.find('#js-city').text(`${cmArr[i].cities[0].name} | ` + codeToRole[cmArr[i].role_type]);
                $clone.find('#user-email').text(cmArr[i].email);

                for (let c in cmArr[i].flags) {

                    let $fClone = this.$flagClone.clone();
                    $fClone.find('.sprite').addClass(`sprite2-${cmArr[i].flags[c].image}`);
                    $flags.push($fClone);
                }
                $clone.find('.js-person-languages').append($flags);

                $people.push($clone);
            }
        }
        return $people;
    },

    /*
    * Selector of <li>
    */
    SelectorCM(e) {
        e && e.preventDefault();

        let $element = $(e.target).closest('.person-contact'),
            emailData = $element.find('#user-email').text(),
            nameCM = $element.find('#js-name').text();

        $('li').removeClass('selected');
        $('div').removeClass('selected');
        $('.1').addClass('is-empty');
        $('.2').addClass('is-empty');

        if (!$element.hasClass('selected')) {
            $element.addClass('selected');
        }
        $('.js-contact').text(nameCM);
        $('#email').attr('value', emailData);
        $('.1').removeClass('is-empty');
        $('.2').removeClass('is-empty');
    },

    /**
     * Activate the form validator plugin
     */
    activateValidator() {
        this.$contactForm.validator({
            disable: false,
            feedback: {
                success: '',
                error: ''
            }
        });
        $.fn.validator.Constructor.FOCUS_OFFSET = 70;
    },

    /**
     * custom form serialization to json data
     * @param $form {jQuery} - form to handle
     */
    jsonSerialize($form) {
        let obj = {};

        $form.serializeArray().forEach((item) => {
            obj[item.name] = item.value;
        });
        return obj;
    },

    checkAllDataInForm() {
        let name = $('#name').val().trim(),
            subject = $('#subject').val().trim(),
            message = $('#message').val().trim(),
            email = $('#email').val().trim(),
            userEmail = $('#userEmail').val().trim();

        if (email.length <= 0) {
            $.snackbar({ content: 'Please, choose a city manager and fill in all the fields in the form', timeout: 6000 });
            return false;
        }

        if (name.length <= 0 || subject.length <= 0 || message.length <= 5 || userEmail.length <= 4) {
            $.snackbar({ content: 'Please, choose a city manager and fill in all the fields in the form', timeout: 6000 });
            return false;
        }
        if (userEmail.indexOf('@') == -1) {
            $.snackbar({ content: 'Please, choose a city manager and fill in all the fields in the form', timeout: 6000 });
            return false;
        }

        return true;
    },


    /**
     * Handle the contact form submission
     * @param {Object} e - the 'submit' event object
     */
    handleContactSubmit(e) {
        let data;
        let nameCM = $('.js-contact').text();

        /* istanbul ignore else  */
        if (!e.isDefaultPrevented()) {
            e.preventDefault();

            if (this.checkAllDataInForm()) {
                let options = {
                    action: 'send this message to ',
                    item: nameCM,
                    onAccept: () => {
                        this.$body.addClass('is-loading');
                        data = this.jsonSerialize(this.$contactForm);
                        // after successful form validation proceed with submission
                        this.submitContactData(data);
                    }
                };
                Confirmbox.open(options);
            }
        }
    },


    /**
     * Submit the user entered data to the api
     * @param {Object} contactData - the user entered contact data
     */
    submitContactData(contactData) {
        // call api when is ready
        window.Api.Inquiry.createOne(contactData)
            .then((response) => {
                this.$body.removeClass('is-loading');
                if (response.isOk) {
                    this.$contactForm[0].reset();
                    $.snackbar({ content: 'Your message was sent successfully!' });
                }
                else {
                    $.snackbar({ content: 'Could not send your message! Please try again.' });
                }
            }, () => {
                this.$body.removeClass('is-loading');
                $.snackbar({ content: 'Could not send your message! Please try again.' });
            });
    },

    closeInviteAllModal(e) {
        e.preventDefault();
        this.$inviteAllModal.close();
    },

    openInviteAllModal(e) {
        e.preventDefault();
        let $id = $(e.target).closest('li').attr('id');

        this.users.map((user) => {
            if (user.role_type == 2 && user.id == $id) {
                this.$inviteAll.data('user-email', user.email);
                this.$inviteAll.find('.js-invite-name').text(`${user.first_name} ${user.last_name}`);
                this.$inviteAll.find('textarea').val('').closest('.form-group').addClass('is-empty');
                this.$inviteAllModal.open();
            }
        });
    },

    inviteAllSubmit(e) {
        e.preventDefault();

        let email = this.$inviteAll.data('user-email');
        let message = this.$inviteAll.find('textarea').val().trim();

        this.$inviteAll.addClass('is-loading');

        window.Api.Event.contactMsg(email, message).then((res) => {
            this.$inviteAll.removeClass('is-loading');

            if (res.isOk) {
                $.snackbar({ content: 'Message sent successfully!' });
                this.$inviteAllModal.close();
            }
            else {
                $.snackbar({ content: 'We couldn\'t send the message at the moment. Please try again later!' });
            }
        }, () => {
            this.$inviteAll.removeClass('is-loading');
            $.snackbar({ content: 'We couldn\'t send the message at the moment. Please try again later!' });
        });
    },

    /**
     * Bind the various UI events
     */
    bindEvents() {
        $(document).on('click', '.js-person-invite-all', this.openInviteAllModal.bind(this));
        this.$inviteAll.on('click', '.js-close-invite-all', this.closeInviteAllModal.bind(this));
        this.$inviteAll.on('click', '.js-invite-all-submit', this.inviteAllSubmit.bind(this));
        this.$contactForm.submit(this.handleContactSubmit.bind(this));
        $(document).on('click', '.person-contact', this.SelectorCM.bind(this));
    }
};

/* istanbul ignore if  */
if (!window.__karma__) {
    Contact.init();
}
export default Contact;
